export default "__VITE_ASSET__CuF1E85s__"